const React = require('react');
const B = require('./B');

module.exports = ({className, ...rest}) => (
  <B
    {...rest}
    className={`(c3E4044)>.c5B47FF` + (className ? ` ${className}` : '')}
  />
);
